import { createRouter, createWebHashHistory } from 'vue-router';
import layout from '../layout/index';

// 路由的name和菜单配置的菜单编号一一对应，用于动态加载菜单，修改时需要同步修改
const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: layout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'dashboard',
        meta: { title: 'menu.homePage', zhTitle: '看板', icon: 'dataBoard' },
        component: () => import(/* webpackChunkName: "about" */ '../views/dataBoard/index.vue'),
      },
    ],
    hidden: false,
  },
  {
    path: '/Management_by_objectives/Goal_SAD',
    name: 'Goal_SAD',
    component: layout,
    meta: {
      title: 'menu.Management_by_objectives_children.Goal_setting_and_decomposition',
      zhTitle: '目标设定与分解',
      icon: 'GoalSAD',
    },
    children: [
      {
        path: 'Absolute_Control',
        name: 'Absolute_Control',
        meta: {
          title: 'menu.Management_by_objectives_children.Absolute_control_Goal',
          zhTitle: '绝对控排目标',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/control.vue'),
      },
      {
        path: 'Project_Goal',
        name: 'Project_Goal',
        meta: {
          title: 'menu.Management_by_objectives_children.reduce_goal',
          zhTitle: '减排目标',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/projectGoal.vue'),
      },
    ],
  },
  // 碳管家
  {
    path: '/carbonButler',
    name: 'carbonButler',
    component: layout,
    meta: { title: 'menu.operate_children.carbon_butler', zhTitle: '碳管家', icon: 'basicModule' },
    children: [
      {
        path: 'inventoryProject',
        name: 'inventoryProject',
        meta: { title: 'menu.carbonInventoryProject', zhTitle: '碳盘查项目' },
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/projectInventory.vue'),
      },
      {
        path: 'inventoryTask',
        name: 'inventoryTask',
        meta: { title: 'menu.carbonInventoryTask', zhTitle: '碳盘查任务' },
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/carbonInventory.vue'),
      },
      {
        path: 'approvalCenter',
        name: 'approvalCenter',
        meta: { title: 'menu.operate_children.carbon_butler_children.approvalCenter', zhTitle: '审批中心' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/AuditPage/auditCenter.vue'),
      },
      {
        path: 'carbonTemplate',
        name: 'carbonTemplate',
        meta: { title: 'menu.carbonTemplate', zhTitle: '碳盘查模板' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonTemplate/index.vue'),
      },
      {
        path: 'certificate',
        name: 'certificate',
        // hidden: true,
        meta: { title: 'menu.certificationReportManagement', zhTitle: '认证报告管理' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/certificate/index.vue'),
      },
      {
        path: 'ReportInventory',
        name: 'ReportInventory',
        meta: { title: 'menu.operate_children.carbon_butler_children.inventory_Project', zhTitle: '盘查详情' },
        hidden: true,
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/reportInventory.vue'),
      },
      // 盘查任务的报告
      {
        path: 'report',
        name: 'report',
        meta: { title: 'menu.operate_children.carbon_butler_children.inventory_Project', zhTitle: '报告详情' },
        hidden: true,
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/reportDetail.vue'),
      },
      // 盘查项目的报告
      {
        path: 'totalReport',
        name: 'totalReport',
        meta: { title: 'menu.operate_children.carbon_butler_children.inventory_Project', zhTitle: '报告详情' },
        hidden: true,
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/reportForProject.vue'),
      },
      // 盘查项目的报告
      {
        path: 'allReport',
        name: 'allReport',
        meta: { title: 'menu.operate_children.carbon_butler_children.inventory_Project', zhTitle: '报告详情' },
        hidden: true,
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonInventory/allReport/index.vue'),
      },
      {
        path: 'viewApprovals',
        name: 'viewApprovals',
        hidden: true,
        meta: { title: 'audit.taskApproval', zhTitle: '查看审批' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/AuditPage/viewApprovals.vue'),
      },
      {
        path: 'reportTemplate',
        name: 'reportTemplate',
        hidden: true,
        meta: { title: 'menu.carbonTemplateReportInventory', zhTitle: '碳盘查模板填报' },
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/carbonButler/carbonTemplate/templateReportInventory.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'Management_by_objectives',
    component: layout,
    // redirect: '/GoalsAndAchievement/Absolute_CASOAA',
    children: [
      // 控排目标与达成
      {
        path: '/Management_by_objectives/GoalsAndAchievement/Absolute_CASOAA',
        name: 'Absolute_CASOAA',
        meta: {
          title: 'menu.controlAndSchedulingGoalsAndAchievement',
          zhTitle: '控排目标与达成',
          icon: 'controlAndSchedulingManagement',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/absoluteControl.vue'),
      },
    ],
    hidden: false,
  },
  // 减排管理
  {
    path: '/ProjectEmissionReduction',
    name: 'ProjectEmissionReduction',
    component: layout,
    meta: {
      title: 'menu.reduceManagement',
      zhTitle: '减排管理',
      icon: 'projectEmissionReduction',
    },
    children: [
      {
        path: 'FoxconnProject',
        name: 'FoxconnProject',
        meta: {
          title: 'menu.projectListEnvironmentalProtectionAndEnergyConservation',
          zhTitle: '专案列表环保节能立项系统',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/hongHaiProject/index.vue'),
      },
      {
        path: 'Project_OAA',
        name: 'Project_OAA',
        meta: {
          title: 'menu.Management_by_objectives_children.Project_objectives_and_achievement',
          zhTitle: '专案目标与达成情况',
        },
        children: [
          {
            path: 'Project',
            name: 'Project',
            meta: {
              title: 'menu.overviewOfProjectStatus',
              zhTitle: '专案状态总览',
            },
            component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/projectControl.vue'),
          },
          {
            path: 'reduce_investment',
            name: 'reduce_investment',
            meta: {
              title: 'menu.overviewOfProjectInvestment',
              zhTitle: '专案投资总览',
            },
            component: () =>
              import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/ReduceInvestment/index.vue'),
          },
        ],
      },
      {
        path: 'Reduce_GAS',
        name: 'Reduce_GAS',
        meta: {
          title: 'menu.analysisOfReduceAchievements',
          zhTitle: 'Reduce目标达成情况',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/reduceGoalStatus/index.vue'),
      },
      // Replace可再生能源使用情况
      {
        path: 'renewable_Energy',
        name: 'renewable_Energy',
        meta: {
          title: 'menu.renewableEnergy',
          zhTitle: 'Replace可再生能源使用情况',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/renewableEnergy/index.vue'),
      },
      {
        path: 'Project_ERPC',
        name: 'Project_ERPC',
        hidden: true,
        meta: {
          title: 'menu.projectEmissionReductionProgressControl',
          zhTitle: '专案进度管控',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ertBusinessGroup/projectProgress.vue'),
      },
      {
        path: 'projectList',
        name: 'projectList',
        hidden: false,
        meta: {
          title: 'project_list.Project_list',
          zhTitle: '专案列表',
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/projectManage/projectList.vue'),
      },
    ],
  },
  // 工作台
  {
    path: '/workbench',
    name: 'workbench',
    component: layout,
    redirect: '/workbench/index',
    meta: { title: 'menu.workbench', zhTitle: '工作台', icon: 'workbench' },
    hidden: false,
    children: [
      {
        path: 'TodoList',
        name: 'TodoList',
        meta: { title: 'menu.workbench_children.To_do_list', zhTitle: '待办列表' },
        component: () => import(/* webpackChunkName: "about" */ '../views/workbench/index.vue'),
      },
      {
        path: 'historyNotice',
        name: 'historyNotice',
        meta: { title: 'audit.historyNotice', zhTitle: '历史通知' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/historyNotice.vue'),
      },
    ],
  },
  // 基础模块
  {
    path: '/BasicModule',
    name: 'BasicModule',
    component: layout,
    meta: { title: 'menu.basicModule', zhTitle: '基础模块', icon: 'basicModule' },
    hidden: false,
    children: [
      {
        path: 'factor',
        name: 'factor',
        meta: { title: 'menu.operate_children.carbon_butler_children.Factor_maintenance', zhTitle: '因子维护' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/backStage/factor.vue'),
      },
      {
        path: 'exchangeRate',
        name: 'exchangeRate',
        meta: { title: 'menu.operate_children.carbon_butler_children.Exchange_rate_table', zhTitle: '基础汇率表' },
        component: () => import(/* webpackChunkName: "about" */ '../views/carbonButler/backStage/exchangeRate.vue'),
      },
    ],
  },
  {
    path: '/organizationalStructure',
    name: 'OrganizationalStructure',
    component: layout,
    meta: { title: 'menu.organizationalStructure', zhTitle: '组织架构', icon: 'organization' },
    children: [
      {
        path: 'orgManage',
        name: 'orgManage',
        meta: { title: 'menu.operate_children.organizational_management', zhTitle: '机构管理' },
        component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/orgManage.vue'),
      },
      {
        path: 'accountManage',
        name: 'accountManage',
        meta: { title: 'menu.operate_children.account_management', zhTitle: '账号管理' },
        component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/accountManage.vue'),
      },
      {
        path: 'roleManage',
        name: 'roleManage',
        meta: { title: 'menu.operate_children.Role_management', zhTitle: '角色管理' },
        component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/roleManage.vue'),
      },
      {
        path: 'menuManage',
        name: 'menuManage',
        meta: { title: 'menu.operate_children.Menu_management', zhTitle: '菜单管理' },
        component: () => import(/* webpackChunkName: "about" */ '../views/authOrization/menuManage.vue'),
      },
    ],
    hidden: false,
  },
  {
    path: '/foxconn',
    name: 'caseDetail',
    component: layout,
    meta: { title: 'menu.operate_children.foxconnProject', zhTitle: '专案列表鸿海系统' },
    children: [
      {
        path: 'caseDetail',
        name: 'caseDetail',
        meta: { title: 'honghai.detail', zhTitle: '专案详情' },
        component: () => import(/* webpackChunkName: "about" */ '../views/hongHaiProject/caseDetail.vue'),
      },
      {
        path: 'ApprovalDetail',
        name: 'ApprovalDetail',
        meta: { title: 'honghai.approval', zhTitle: '签核详情' },
        component: () => import(/* webpackChunkName: "about" */ '../views/hongHaiProject/ApprovalDetail.vue'),
      },
    ],
    hidden: true,
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import(/* webpackChunkName: "about" */ '@/views/login/index.vue'),
  },
  // 外部跳转中转界面
  {
    path: '/apply',
    name: 'apply',
    hidden: true,
    component: () => import(/* webpackChunkName: "about" */ '@/views/login/apply.vue'),
  },
  {
    path: '/cockpit',
    name: 'cockpit',
    hidden: true,
    component: () => import(/* webpackChunkName: "about" */ '@/views/cockpit/cockpit.vue'),
  },
  {
    path: '/map',
    name: 'map',
    hidden: true,
    component: () => import(/* webpackChunkName: "about" */ '@/components/map/cesiumViewer.vue'),
  },
  // {
  //   path: '/cockpit1',
  //   name: 'cockpit1',
  //   hidden: true,
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/cockpit/index.vue'),
  // },

  {
    path: '/preview',
    name: 'preview',
    hidden: true,
    component: () => import(/* webpackChunkName: "about" */ '@/views/ertBusinessGroup/preview.vue'),
  },
  {
    path: '/',
    name: 'userInfo',
    component: layout,
    redirect: '/userInfo/index',
    children: [
      {
        path: '/userInfo',
        name: 'userInfo',
        meta: { title: 'menu.user', zhTitle: '个人中心', icon: 'Menu' },
        component: () => import(/* webpackChunkName: "about" */ '../views/user/userInfo.vue'),
      },
    ],
    hidden: false,
  },
];

const router = createRouter({
  history: createWebHashHistory(), //hash模式
  // history: createWebHistory(process.env.BASE_URL), // history模式
  routes,
});

router.afterEach((to, from) => {
  sessionStorage.setItem('curRoute', router.currentRoute.value.fullPath);
  // to and from are both route objects.
});

export default router;
